import axios, { resHandle } from "@/plugins/axios";


/**
 * @description 获取项目模板字典列表
 * @param vCom Vue组件
 * @param type 系统模板或者自定义模板
 */
const GetDictionary = (vCom: any, type: string): Promise<any> => {
    const params: any = {
        params: {
            type
        }
    };
    return new Promise((resolve, reject) => {
        axios.get("api/project/dictionary", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};






export { GetDictionary };

